import React, { Component } from 'react';
import { Container, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Todo from "../Todo/Todo";
import Plan from '../Todo/AccordionPlan';
import WeeklyReport from '../Todo/WeeklyReport';

class TodoAdmin extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "Team Admin", link : "#" },
                { title : "Manager", link : "#" },
            ],
        }
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Team Admin Page" breadcrumbItems={this.state.breadcrumbItems} />

                        <Row>
                            <Todo/>
                        </Row>

                        <Row>
                            <WeeklyReport/>
                        </Row>

                        <Row>
                            <Plan/>
                        </Row>
                        
                        
                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default TodoAdmin;